import { useEffect } from 'react';
import { Empty, Typography, Table, Tag } from 'antd';
import { useSingleService } from './SingleServiceStore';

const { Text } = Typography;

const statusMap = {
    pending: { color: 'orange', label: 'Kutilmoqda' },
    confirmed: { color: 'blue', label: 'Tasdiqlangan' },
    completed: { color: 'green', label: 'Bajarilgan' },
    cancelled: { color: 'red', label: 'Bekor qilingan' },
};

function ServiceOrders({ serviceId }) {
    const { orders, getOrders } = useSingleService();

    useEffect(() => {
        if (serviceId) getOrders(serviceId);
    }, [serviceId, getOrders]);

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
        { title: 'Mijoz', dataIndex: 'client_name', key: 'client_name', render: (v) => v || '—' },
        { title: 'Telefon', dataIndex: 'client_phone', key: 'client_phone', render: (v) => v || '—' },
        {
            title: 'Holati', dataIndex: 'status', key: 'status',
            render: (status) => {
                const s = statusMap[status] || { color: 'default', label: status || '—' };
                return <Tag color={s.color}>{s.label}</Tag>;
            },
        },
        { title: 'Summa', dataIndex: 'summa', key: 'summa', render: (v) => v ? `${Number(v).toLocaleString()} so'm` : '—' },
        {
            title: 'Sana', key: 'date',
            render: (_, rec) => {
                if (rec.day && rec.month && rec.year) return `${rec.day}.${String(rec.month).padStart(2, '0')}.${rec.year}`;
                return '—';
            },
        },
        { title: 'Vaqt', dataIndex: 'start', key: 'start', render: (v, rec) => v ? `${v}${rec.end ? ' - ' + rec.end : ''}` : '—' },
        { title: 'Soni', dataIndex: 'quantity', key: 'quantity' },
        { title: 'Izoh', dataIndex: 'note', key: 'note', ellipsis: true },
        { title: 'Yaratilgan', dataIndex: 'created', key: 'created', render: (v) => v ? String(v).slice(0, 16) : '—' },
    ];

    return (
        <div style={{ padding: '16px 0' }}>
            <div style={{ marginBottom: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Buyurtmalar ({orders.length})</Text>
            </div>
            <Table
                dataSource={orders}
                columns={columns}
                rowKey="id"
                size="small"
                scroll={{ x: 'max-content' }}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Buyurtmalar yo'q" /> }}
            />
        </div>
    );
}

export default ServiceOrders;
